import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

@Injectable({
    providedIn: 'root'
})
export class AppOverlayContainer extends OverlayContainer {

    getContainerElement(): HTMLElement {
        let isAdminPage = this._document.querySelector('nb-layout');
        if (isAdminPage && this._document.querySelector('nb-layout .cdk-overlay-container')) {
            this._containerElement = this._document.querySelector('nb-layout .cdk-overlay-container')
        } else if (isAdminPage && !this._document.querySelector('nb-layout .cdk-overlay-container')) {
            this._createContainer();
        } else if (!isAdminPage && this._document.querySelector('body > .cdk-overlay-container')) {
            this._containerElement = this._document.querySelector('body > .cdk-overlay-container');
        } else if (!isAdminPage && !this._document.querySelector('body > .cdk-overlay-container')) {
            this._createContainer();
        }
        return this._containerElement;
    }

    protected _createContainer(): void {
        let isAdminPage = this._document.querySelector('nb-layout');
        const containerClass = 'cdk-overlay-container';

        const container = this._document.createElement('div');
        container.classList.add(containerClass);
        if (isAdminPage) {
            this._document.querySelector('nb-layout').appendChild(container);
        } else {
            this._document.body.appendChild(container);
        }
        this._containerElement = container;
    }

}
